export const shouldScheduleToastDismiss = (duration?: number): boolean =>
  Number.isFinite(duration) && (duration as number) > 0
